/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/v1/login": {
    post: operations["AccountController_login"]
  }
  "/v1/accounts:getByPrincipal": {
    post: operations["AccountController_getByPrincipal"]
  }
  "/v1/accounts/{uid}": {
    get: operations["AccountController_getAccountDetailsById"]
  }
  "/v1/accounts/pnl/{uid}/today": {
    get: operations["AccountController_getAccountTodayPnlById"]
  }
  "/v1/assets": {
    get: operations["AccountController_getAssets"]
  }
  "/v1/accounts/{uid}:updateSettings": {
    post: operations["AccountController_updateAccountSettings"]
  }
  "/v1/accounts/{uid}:sendVerificationEmail": {
    post: operations["AccountController_sendVerificationEmail"]
  }
  "/v1/accounts/{uid}:verifyEmail": {
    post: operations["AccountController_verifyEmail"]
  }
  "/v1/accounts/{uid}/fund-history": {
    get: operations["AccountController_getFundHistory"]
  }
  "/v1/orders": {
    get: operations["OrderController_getOrders"]
    post: operations["OrderController_createOrder"]
  }
  "/v1/orders:make": {
    post: operations["OrderController_convertOrder"]
  }
  "/v1/orderbook/{market}": {
    get: operations["OrderController_getOrderBook"]
  }
  "/v1/orders/{order_hash}": {
    get: operations["OrderController_getOrder"]
  }
  "/v1/orders/{order_hash}:cancel": {
    post: operations["OrderController_cancelOrder"]
  }
  "/v1/orders:cancel_all": {
    post: operations["OrderController_cancelOrders"]
  }
  "/v1/orderbook/{market}:ticker": {
    get: operations["OrderController_getOrderBookTicker"]
  }
  "/v1/orderbook:tickers": {
    get: operations["OrderController_getOrderBookTickers"]
  }
  "/v1/orderbook/{market}:price": {
    get: operations["OrderController_getPriceTicker"]
  }
  "/v1/fills": {
    get: operations["OrderController_getFills"]
  }
  "/v1/orderbook/{market}:fills": {
    get: operations["OrderController_getMarketFills"]
  }
  "/v1/orderbook/{market}:trades": {
    get: operations["OrderController_getMarketTrades"]
  }
  "/v1/orderbook/{market}:trading-view": {
    get: operations["OrderController_getTradingView"]
  }
  "/v1/orderbook/{market}:overview": {
    get: operations["OrderController_getTradeOverview"]
  }
}

export interface components {
  schemas: {
    LoginRequest: {
      payload: string
      signature: string
    }
    GetAccountRequest: {
      principal: string
    }
    GetAccountInfoResponse: {
      uid: string
      principal: string
      public_key: string
      email: string
      username: string
      email_subscription_enabled: boolean
      email_verified: boolean
    }
    UserBalanceDetail: {
      asset_name: string
      asset_id: string
      /** @description funds in wallet, might be negative if you've used your incoming funds */
      balance: string
      /** @description available balance for creating orders, considering locked, withdrawing and incoming funds, always non-negative */
      available: string
      /** @description incoming funds for matched but not yet settled orders */
      incoming: string
      /** @description locked amount for open orders */
      locked: string
      /** @description requested amount to withdraw */
      pending_withdraw: string
    }
    GetAccountDetailsResponse: {
      uid: string
      principal: string
      public_key: string
      balances: components["schemas"]["UserBalanceDetail"][]
    }
    AssetInfoDTO: {
      assetName: string
      assetId: string
      /** @description Today's initial balance */
      initialBalance: string
      /** @description Today's starting block height */
      startBlockHeight: string
      /** @description Today's net transfer */
      netTransfer: string
      deposit: string
      /** @description Current balance */
      balance: string
    }
    GetAccountPnlInfoResponse: {
      uid: string
      today_pnl: string
      today_pnl_percent: string
      balances: components["schemas"]["AssetInfoDTO"][]
    }
    AssetResponse: {
      assetId: string
      asset: string
    }
    UpdateAccountSettingRequest: {
      email: string
      username: string
      email_subscription_enabled: boolean
    }
    SendVerificationEmailRequest: {
      email: string
    }
    VerifyEmailRequest: {
      token: string
    }
    BaseFundResponse: {
      asset_id: string
      /** @enum {string} */
      type: "deposit" | "withdraw"
      /** @enum {string} */
      status: "pending" | "failed" | "confirmed"
      amount: string
      tx_id: string
      created_at: string
    }
    GetFundsResponse: {
      history: components["schemas"]["BaseFundResponse"][]
    }
    CreateOrderRequest: {
      order: string
      signature: string
    }
    CreateOrderResponse: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      /** @enum {string} */
      side: "buy" | "sell"
      price: string
      risk: boolean
      maker: string
      size: string
      /** @enum {string} */
      type: "vanilla" | "fok" | "ioc"
      salt: string
      timestamp: string
      sender_fee: string
      stop_price: string
      expiration_height: string
    }
    ConvertOrderRequest: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      /** @enum {string} */
      side: "buy" | "sell"
      price: string
      risk: boolean
      maker: string
      size: string
      /** @enum {string} */
      type: "vanilla" | "fok" | "ioc"
      salt?: string
      stop_price?: string
      timestamp?: string
      sender_fee: string
      expiration_height: string
    }
    ConvertOrderResponse: {
      type: string
      "expiration-height": string
      "maker-asset": string
      "maker-asset-data": string
      "maximum-fill": string
      sender: string
      "sender-fee": string
      "taker-asset": string
      "taker-asset-data": string
      maker: string
      salt: string
      timestamp: string
      stop: string
      risk: boolean
    }
    OrderBookPriceSize: {
      price: string
      size: string
    }
    GetOrderBookResponse: {
      bids: components["schemas"]["OrderBookPriceSize"][]
      asks: components["schemas"]["OrderBookPriceSize"][]
    }
    BaseRenderOrderResponse: {
      /** @enum {string} */
      type: "vanilla" | "fok" | "ioc"
      order_hash: string
      maker: string
      created_at: string
      /** @enum {string} */
      status: "matching" | "matched" | "settled" | "expired" | "canceled"
      salt: string
      /** @enum {string} */
      side: "buy" | "sell"
      size: string
      remaining_size: string
      price: string
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      sender_fee: string
      taker_asset_data: string
      maker_asset_data: string
      taker_asset: string
      maker_asset: string
      maximum_fill: string
      unsettle_filled: string
      filled: string
      avg_settled_price: string
      expiration_height: string
      stop_price: string
      risk: boolean
    }
    GetOrdersResponse: {
      orders: components["schemas"]["BaseRenderOrderResponse"][]
    }
    GetOrderResponse: {
      order: components["schemas"]["BaseRenderOrderResponse"]
    }
    CancelOrdersDTO: {
      /** @enum {string} */
      market?: "BTC-USD" | "ALEX-USD" | "STX-USD"
    }
    CancelOrdersResponse: {
      orders: string[]
    }
    GetOrderBookTickerResponse: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      bid: string
      bid_size: string
      ask: string
      ask_size: string
    }
    OrderBookTickerDTO: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      bid: string
      bid_size: string
      ask: string
      ask_size: string
    }
    GetOrderBookTickersResponse: {
      tickers: components["schemas"]["OrderBookTickerDTO"][]
    }
    GetPriceTickerResponse: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      price: string
    }
    OrderFillDTO: {
      id: number
      tx_id?: string
      /** @enum {string} */
      status:
        | "matched"
        | "assigned"
        | "generated"
        | "submitted"
        | "pending"
        | "settled"
        | "failed"
        | "fatal"
      sender_fee: string
      maker: string
      maker_asset: string
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      /** @enum {string} */
      side: "buy" | "sell"
      /** @enum {string} */
      type: "vanilla" | "fok" | "ioc"
      price: string
      fill_fixed: string
      size: string
      created_at: number
    }
    GetOrderFillsResponse: {
      fills: components["schemas"]["OrderFillDTO"][]
    }
    MarketTrade: {
      timestamp: number
      price: string
      size: string
      left_hash: string
      left_maker: number
      /** @enum {string} */
      left_side: "buy" | "sell"
      right_hash: string
      right_maker: number
      /** @enum {string} */
      right_side: "buy" | "sell"
    }
    GetMarketTradesResponse: {
      trades: components["schemas"]["MarketTrade"][]
    }
    TradingViewDataMetadata: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      /** @description resolution in minutes */
      resolution: number
      /** @description UNIX timestamp for latest update */
      lastUpdate: number
      /** @description UNIX timestamp for next timestamp before the returning range if there is any */
      nextTime?: number
      /** @description Currently fixed to UTC */
      timezone: string
      /** @description Currently fixed to: ['range_start', 'open', 'high', 'low', 'close', 'volume'] */
      columns: [string, string, string, string, string, string]
    }
    TradingViewResponse: {
      metadata: components["schemas"]["TradingViewDataMetadata"]
      /** @description ['range_start', 'open', 'high', 'low', 'close', 'volume'] */
      series: [string, string, string, string, string, string][]
    }
    GetTradeOverviewResponse: {
      /** @enum {string} */
      market: "BTC-USD" | "ALEX-USD" | "STX-USD"
      last_price: string
      price_24h_change: string
      price_24h_change_percent: string
      lowest_price: string
      highest_price: string
      volume_24h: string
      amount_24h: string
    }
  }
}

export interface operations {
  AccountController_login: {
    parameters: {}
    responses: {
      201: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["LoginRequest"]
      }
    }
  }
  AccountController_getByPrincipal: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetAccountInfoResponse"]
        }
      }
      404: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["GetAccountRequest"]
      }
    }
  }
  AccountController_getAccountDetailsById: {
    parameters: {
      path: {
        uid: unknown
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetAccountDetailsResponse"]
        }
      }
      404: unknown
    }
  }
  AccountController_getAccountTodayPnlById: {
    parameters: {
      path: {
        uid: unknown
      }
    }
    responses: {
      /** * See `GetAccountPnlInfoResponse` for details about pnl of today */
      200: {
        content: {
          "application/json": components["schemas"]["GetAccountPnlInfoResponse"]
        }
      }
      404: unknown
    }
  }
  AccountController_getAssets: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["AssetResponse"]
        }
      }
    }
  }
  AccountController_updateAccountSettings: {
    parameters: {
      path: {
        uid: unknown
      }
    }
    responses: {
      409: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["UpdateAccountSettingRequest"]
      }
    }
  }
  AccountController_sendVerificationEmail: {
    parameters: {
      path: {
        uid: unknown
      }
    }
    responses: {
      404: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["SendVerificationEmailRequest"]
      }
    }
  }
  AccountController_verifyEmail: {
    parameters: {
      path: {
        uid: unknown
      }
    }
    responses: {
      404: unknown
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["VerifyEmailRequest"]
      }
    }
  }
  AccountController_getFundHistory: {
    parameters: {
      path: {
        uid: unknown
      }
      query: {
        limit?: number
        /**
         * * return funds **before or equal** the timestamp,
         *       equals to ` where created_at <= before `
         *   * format as number of milliseconds elapsed since January 1, 1970 00:00:00 UTC
         */
        before?: number
        /**
         * * return funds **after** the timestamp,
         *         equals to ` where created_at > after `
         *   * format as number of milliseconds elapsed since January 1, 1970 00:00:00 UTC
         */
        after?: number
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetFundsResponse"]
        }
      }
    }
  }
  OrderController_getOrders: {
    parameters: {
      query: {
        status?: "matching" | "matched" | "settled" | "expired" | "canceled"
        market?: "BTC-USD" | "ALEX-USD" | "STX-USD"
        side?: "buy" | "sell"
        limit?: number
        /**
         * * return orders **before or equal** the timestamp,
         *     equals to ` where created_at <= before `
         * * format as number of milliseconds elapsed since January 1, 1970 00:00:00 UTC
         */
        before?: number
        /**
         * * return orders **after** the timestamp,
         *       equals to ` where created_at > after `
         * * format as number of milliseconds elapsed since January 1, 1970 00:00:00 UTC
         */
        after?: number
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrdersResponse"]
        }
      }
    }
  }
  OrderController_createOrder: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CreateOrderResponse"]
        }
      }
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateOrderRequest"]
      }
    }
  }
  OrderController_convertOrder: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["ConvertOrderResponse"]
        }
      }
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["ConvertOrderRequest"]
      }
    }
  }
  OrderController_getOrderBook: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderBookResponse"]
        }
      }
    }
  }
  OrderController_getOrder: {
    parameters: {
      path: {
        order_hash: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderResponse"]
        }
      }
    }
  }
  OrderController_cancelOrder: {
    parameters: {
      path: {
        order_hash: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderResponse"]
        }
      }
    }
  }
  OrderController_cancelOrders: {
    parameters: {}
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["CancelOrdersResponse"]
        }
      }
    }
    requestBody: {
      content: {
        "application/json": components["schemas"]["CancelOrdersDTO"]
      }
    }
  }
  OrderController_getOrderBookTicker: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderBookTickerResponse"]
        }
      }
    }
  }
  OrderController_getOrderBookTickers: {
    parameters: {
      query: {
        markets?: string[]
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderBookTickersResponse"]
        }
      }
    }
  }
  OrderController_getPriceTicker: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetPriceTickerResponse"]
        }
      }
    }
  }
  OrderController_getFills: {
    parameters: {
      query: {
        /** market */
        market?: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderFillsResponse"]
        }
      }
    }
  }
  OrderController_getMarketFills: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetOrderFillsResponse"]
        }
      }
    }
  }
  OrderController_getMarketTrades: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetMarketTradesResponse"]
        }
      }
    }
  }
  OrderController_getTradingView: {
    parameters: {
      path: {
        market: string
      }
      query: {
        /** resolution in minutes, must be positive number */
        resolution: number
        /** if set, the from parameter will be ignored */
        countback?: number
        /** UNIX timestamp before `to`, required if countback is not provided */
        from?: number
        /** UNIX timestamp in the past aligned with resolution or `now` */
        to: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["TradingViewResponse"]
        }
      }
    }
  }
  OrderController_getTradeOverview: {
    parameters: {
      path: {
        market: string
      }
    }
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["GetTradeOverviewResponse"]
        }
      }
    }
  }
}

export interface external {}

export namespace ApiPaths {
  export const AccountController_login = {
    url: "/v1/login" as const,
    method: "post" as const,
  }
  export const AccountController_getByPrincipal = {
    url: "/v1/accounts:getByPrincipal" as const,
    method: "post" as const,
  }
  export const AccountController_getAccountDetailsById = {
    url: "/v1/accounts/{uid}" as const,
    method: "get" as const,
  }
  export const AccountController_getAccountTodayPnlById = {
    url: "/v1/accounts/pnl/{uid}/today" as const,
    method: "get" as const,
  }
  export const AccountController_getAssets = {
    url: "/v1/assets" as const,
    method: "get" as const,
  }
  export const AccountController_updateAccountSettings = {
    url: "/v1/accounts/{uid}:updateSettings" as const,
    method: "post" as const,
  }
  export const AccountController_sendVerificationEmail = {
    url: "/v1/accounts/{uid}:sendVerificationEmail" as const,
    method: "post" as const,
  }
  export const AccountController_verifyEmail = {
    url: "/v1/accounts/{uid}:verifyEmail" as const,
    method: "post" as const,
  }
  export const AccountController_getFundHistory = {
    url: "/v1/accounts/{uid}/fund-history" as const,
    method: "get" as const,
  }
  export const OrderController_createOrder = {
    url: "/v1/orders" as const,
    method: "post" as const,
  }
  export const OrderController_getOrders = {
    url: "/v1/orders" as const,
    method: "get" as const,
  }
  export const OrderController_convertOrder = {
    url: "/v1/orders:make" as const,
    method: "post" as const,
  }
  export const OrderController_getOrderBook = {
    url: "/v1/orderbook/{market}" as const,
    method: "get" as const,
  }
  export const OrderController_getOrder = {
    url: "/v1/orders/{order_hash}" as const,
    method: "get" as const,
  }
  export const OrderController_cancelOrder = {
    url: "/v1/orders/{order_hash}:cancel" as const,
    method: "post" as const,
  }
  export const OrderController_cancelOrders = {
    url: "/v1/orders:cancel_all" as const,
    method: "post" as const,
  }
  export const OrderController_getOrderBookTicker = {
    url: "/v1/orderbook/{market}:ticker" as const,
    method: "get" as const,
  }
  export const OrderController_getOrderBookTickers = {
    url: "/v1/orderbook:tickers" as const,
    method: "get" as const,
  }
  export const OrderController_getPriceTicker = {
    url: "/v1/orderbook/{market}:price" as const,
    method: "get" as const,
  }
  export const OrderController_getFills = {
    url: "/v1/fills" as const,
    method: "get" as const,
  }
  export const OrderController_getMarketFills = {
    url: "/v1/orderbook/{market}:fills" as const,
    method: "get" as const,
  }
  export const OrderController_getMarketTrades = {
    url: "/v1/orderbook/{market}:trades" as const,
    method: "get" as const,
  }
  export const OrderController_getTradingView = {
    url: "/v1/orderbook/{market}:trading-view" as const,
    method: "get" as const,
  }
  export const OrderController_getTradeOverview = {
    url: "/v1/orderbook/{market}:overview" as const,
    method: "get" as const,
  }
}
